module.exports = __webpack_public_path__ + "img/ic-pwp-arrow-right.svg";